import { darken } from 'polished';

import { styled } from '../../hooks/theme';
import { Tokens } from '../../types';

export const Container = styled.div`
  position: relative;

  overflow: visible;
  width: fit-content;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #f1f4f5;
    border-radius: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.neutral.grey[40]};
    border-radius: 8px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${props => darken(0.1, props.theme.colors.neutral.grey[40])};
  }
`;
Container.defaultProps = {
  theme: Tokens.eixods,
};

export const TableContainer = styled.table`
  border-spacing: 0;
  border-collapse: separate;

  table-layout: fixed;
  width: 100%;
`;

export const TableHeader = styled.thead`
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
`;

export const TableHeaderRow = styled.tr`
  border-radius: 8px;

  th:first-child {
    border-radius: 10px 0 0 10px;
  }

  th:last-child {
    border-radius: 0 10px 10px 0;
  }
`;

export const TableHeaderCell = styled.th`
  padding: 17.5px 24px;
  color: ${props => props.theme.colors.neutral.grey[100]};
  background: ${props => props.theme.colors.neutral.grey[5]};
  cursor: pointer;

  text-align: left;

  div {
    display: flex;
    align-items: center;
  }
`;
TableHeaderCell.defaultProps = {
  theme: Tokens.eixods,
};

export const TableBody = styled.tbody``;

export const TableRow = styled.tr``;

export const TableDataCell = styled.td`
  padding: 17.5px 24px;

  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  border-bottom: 1px solid ${props => props.theme.colors.neutral.grey[10]};
`;
TableDataCell.defaultProps = {
  theme: Tokens.eixods,
};

export const NoDataContainer = styled.div`
  width: 400px;
  padding: 80px;

  text-align: center;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h4 {
    margin-top: 8px;
    margin-bottom: 16px;
    font-size: ${props => props.theme.font.size['4xl']}px;
  }
`;
NoDataContainer.defaultProps = {
  theme: Tokens.eixods,
};

export const LoadingContainer = styled.div`
  position: absolute;
  top: 30%;
`;

export const LoadingBackground = styled.div`
  position: absolute;

  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: rgba(250, 250, 250, 0.65);
`;
